import React, { useState, useEffect } from "react";
import SelectForm from "../../Components/SelectForm/SelectForm";
import InputForm, { AutoCompleteValue } from "../../Components/InputForm/InputForm";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import { APICall } from "../../Helpers/Network/APICalls";
import moment from "moment";
import notify, { ToastType } from "../../Helpers/ToastNotification";
import { documentDetails, loanModuleGetPersonalDetailsByMemberId, postPersonalCurrentSalarySlipAndChequeBook } from "../../Helpers/APIEndPoints/EndPoints";
import ButtonComponent from "../../Components/ButtonForm/Button";
import { useNavigate } from "react-router-dom";
import { ApiStatus } from "../../Helpers/Enums/ApiStatus";
import { LoanStatus } from "../../Helpers/Enums/ApplicationStatus";
import { downloadBlob } from "../../Helpers/Common/BlobHelper";
import ImageViewer from "../../Components/ImageViewer/ImageViewer";
import { Tooltip } from "react-bootstrap";
import { BsImage } from "react-icons/bs";
import { useSelector } from "react-redux";
import { RoleEnum } from "../../Helpers/Enums/RoleEnum";

const LAPersonalDetails = (props) => {
  const context = getContext();
  let { selectNextTab } = props;
  let navigate = useNavigate();
  const [data, setData] = useState({
    memberNo: null,
    tokenNo: null,
    company: "",
    unitcode: "",
    sector: null,
    emailId: "",
    mobileNo: null,
    location: "",
    uploadSalarySlip: null,
  });
  const [error, setError] = useState<any>({});
  const { showLoader, hideLoader } = React.useContext(LoaderContext);
  const [disabled, setDisabled] = useState(true);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [approvalStatus, setApprovalStatus] = useState();
  const [salarySlipUploadDisabled, setSalarySlipUploadDisabled] = useState(true);
  const [goNext, setGoNext] = useState(true);
  const [salarySlipName, setSalarySlipName] = useState(null);
  const [binaryDataSalSlip, setBinaryDataSalSlip] = useState(null);
  const [salarySlipId, setSalarySlipId] = useState();
  const [chequeId, setChequeId] = useState(null);
  const [images, setImages] = useState([]);
  const [imageIndex, setImageIndex] = useState<number>(null);
  const [imageEyeIconVisibleNextTab, setImageEyeIconVisibleNextTab] = useState(false);
  const [loanRequestId, setLoanRequestId] = useState(0);
  const [showImageViewer, setShowImageViewer] = useState<boolean>(false);
  let documentId = [];
  let MemberId = context.MemberId;
  const loanParameters = useSelector<any>((state) => state?.LoanModuleReducer?.loanParameters);

  useEffect(() => {
    getPersonalDetailsByIdApiCallll();
  }, []);

  useEffect(() => {
    if (imageIndex !== null) {
      setShowImageViewer(true);
    }
  }, [imageIndex]);

  useEffect(() => {
    if (!showImageViewer) {
      setImageIndex(null);
    }
  }, [showImageViewer]);

  const getPersonalDetailsByIdApiCallll = async () => {
    showLoader();
    // let requestParams = { MemberId: MemberId };
    let requestParams = loanParameters;
    const res = await APICall(loanModuleGetPersonalDetailsByMemberId, requestParams);

    if (res.Message === "Ok" && res.Data !== null) {
      let data = {
        tokenNo: Number(res?.Data?.TokenNo),
        emailId: res?.Data?.EmailId,
        memberNo: res?.Data?.MemberNo,
        mobileNo: Number(res?.Data?.MobileNumber),
        company: res?.Data?.Company,
        unitcode: res?.Data?.UnitCode,
        sector: res?.Data?.Sector,
        location: res?.Data?.Location,
        uploadSalarySlip: "",
      };
      setSalarySlipName(res?.Data?.SalarySlip_Name);
      setData(data);
      setApprovalStatus(res?.Data?.Lrd_StatusId);
      setSalarySlipId(res?.Data?.Lrd_CurrentMonthSalarySlipDocId);
      setChequeId(res?.Data?.Lrd_CancelChequePassbookDocId);
      setLoanRequestId(res?.Data?.Lrd_Id);
      if (res?.Data?.Lrd_CurrentMonthSalarySlipDocId != 0) {
        setImageEyeIconVisibleNextTab(true);
      }
      let newImages = [];
      const img = res?.Data?.SalarySlip_Url;
      let imgUrl = await downloadBlob(img);
      let fileType = img?.toLowerCase()?.endsWith(".pdf") ? "pdf" : "image";
      newImages.push({
        src: imgUrl,
        fileType: fileType,
        title: "Salary Slip" + res?.Data?.Mkd_AccountHolderName,
      });
      setImages(newImages);
      
      if(res?.Data?.SalarySlip_Url){
        setGoNext(false);
      }


      if ([LoanStatus.LoanModule_RejectedByInternalTeam].includes(res?.Data?.Lrd_StatusId)) {
        setGoNext(false);
      }

      if ([LoanStatus.LoanModule_RejectedByInternalTeam, LoanStatus.LoanModule_Draft].includes(res?.Data?.Lrd_StatusId)) {
        if (context?.CurrentRoleId === RoleEnum.Member) {
          setSalarySlipUploadDisabled(false);
        } else {
          setSalarySlipUploadDisabled(true);
        }
      } else if (
        [
          LoanStatus.LoanModule_AllSuretyApproved,
          LoanStatus.LoanModule_PendingWithInternalTeam,
          LoanStatus.LoanModule_LoanApplicationCancelledByMember,
          LoanStatus.LoanModule_LoanApplicationRejected,
          LoanStatus.LoanModule_MemberSignaturePending,
          LoanStatus.LoanModule_MemberSignatureVerificationPendingByInternalTeam,
          LoanStatus.LoanModule_MemberSignatureVerificationRejected,
          LoanStatus.LoanModule_LoanCommitteeApprovalPending,
          LoanStatus.LoanModule_MemberAgreementRejected,
          LoanStatus.LoanModule_LoanFinalApprovalPending,
          LoanStatus.LoanModule_DocumentGenerationPending,
          LoanStatus.LoanModule_LoanApplicationApproved,
          LoanStatus.LoanModule_PendingMemberLoanConfirmation,
          LoanStatus.LoanModule_SuretyApprovalPending,
        ].includes(res?.Data?.Lrd_StatusId)
      ) {
        setSalarySlipUploadDisabled(true);
      }

      hideLoader();
    } else {
      notify(ToastType.Error, "Data not found");
      hideLoader();
    }
  };

  const onChange = (key, value) => {
    setData({ ...data, [key]: value });
  };

  const isFile = (input: any) => "File" in window && input instanceof File;

  const getBase64FromFilePromise = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      if (isFile(file) === true) {
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
      }
      reader.onerror = (error) => reject(error);
    });

  const onChangeUploadSalarySlip = async (key, value) => {
    if (key === "uploadSalarySlip" && value.target.files.length > 0) {
      let errormessage = "salarySlipError";

      let e = value.target.files[0].name;
      let file = value.target.files[0];
      let extension = ["jpeg", "png", "jpg", "pdf"];
      let validfile = e.split(".").pop();
      setSalarySlipName(e);
      if (!extension.includes(validfile)) {
        setError({
          ...error,
          [errormessage]: "File should be only jpeg or png or pdf",
        });
        value = file.name;
      } else if (file.size / 1024 / 1024 > 2) {
        setError({
          ...error,
          [errormessage]: "Please select file size upto 2mb",
        });
        value = file.name;
      } else {
        setError({
          ...error,
          [errormessage]: "",
        });
        
        let tempString = await getBase64FromFilePromise(file);
        let fileBase64 = "";
        if (tempString && tempString !== "") {
          fileBase64 = String(tempString).split("base64,")[1];
        }

        setImageEyeIconVisibleNextTab(false);
        setBinaryDataSalSlip(fileBase64);
        if (fileBase64) {
          setGoNext(true);
        }

        value = fileBase64;
      }
    }
    setData({ ...data, [key]: value });
  };

  const handleKeyNumbers = (event) => {
    const charCode = event.which || event.keyCode; // Handle cross-browser compatibility
    if (charCode >= 48 && charCode <= 57) {
      // Prevent numeric character input
      event.preventDefault();
    }
  };

  const GoToNextTab = async () => {
    
    // if (
    //   ![
    //     LoanStatus.LoanModule_RejectedByInternalTeam,
    //     LoanStatus.LoanModule_Draft,
    //   ].includes(approvalStatus) &&
    //   imageEyeIconVisibleNextTab
    // ) {
    await selectNextTab();
    //   return;
    // }
    // if (!goNext) {

    // }
  };

  const onSubmit = async () => {
    let errorObj = {};
    
    if (!binaryDataSalSlip) {
      errorObj = {
        ...errorObj,
        ["salarySlipError"]: "Invalid Salary Slip",
      };
    }

    if (Object.keys(errorObj).length <= 0) {
      showLoader();

      if (binaryDataSalSlip) {
        for (const key in data) {
          if (key == "uploadSalarySlip") {
            let param = {
              DocumentName: salarySlipName,
              DocumentType: salarySlipName.split(".").pop(),
              DocumentUrl: "",
              BinaryFile: binaryDataSalSlip || data.uploadSalarySlip,
            };
            const insertData = await APICall(documentDetails, param);
            if (insertData.Status === ApiStatus.OK && insertData?.Data) {
              let obj = { [key]: insertData.Data };
              documentId.push(obj);
            } else {
              notify(ToastType.Error, insertData?.Message || "Failed to upload document, Please try again later.");
              hideLoader();
              return;
            }
          }
        }
        if (!(documentId?.length > 0)) {
          notify(ToastType.Error, "Failed to upload document, Please try again later.");
          hideLoader();
          return;
        }
      }

      let param = {
        LoanRequestId: loanRequestId,
        MemberId: MemberId,
        CancelChequePassbookDocId: chequeId,
        CurrentMonthSalarySlipDocId: binaryDataSalSlip ? documentId[0]?.uploadSalarySlip : salarySlipId,
        StatusId: approvalStatus == LoanStatus.LoanModule_RejectedByInternalTeam ? LoanStatus.LoanModule_RejectedByInternalTeam : LoanStatus.LoanModule_Draft,
      };
      
      const insertData = await APICall(postPersonalCurrentSalarySlipAndChequeBook, param);
      if (insertData.Status === ApiStatus.OK) {
        // notify(ToastType.Success, "Successfully data inserted");
        await selectNextTab();
      } else {
        notify(ToastType.Error, insertData?.Message || "Failed to save details, Please try again later.");
      }
      hideLoader();
    } else {
      setError(errorObj);
    }
  };

  return (
    <div className="p-0">
      <div className="col-lg-12 col-md-12 ">
        <div className="row" style={{ marginLeft: "-30px", marginRight: "-30px" }}>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Member No</label>
            <InputForm
              placeholder={""}
              value={data.memberNo}
              onChange={(val: any) => {
                let value = val.target.value;
                onChange("memberNo", value);
              }}
              isDisabled={disabled}
              onKeyPress={handleKeyNumbers}
            />
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Token No</label>
            <InputForm
              placeholder={""}
              value={data.tokenNo}
              onChange={(val: any) => {
                let value = val.target.value;
                onChange("tokenNo", value);
              }}
              isDisabled={disabled}
              onKeyPress={handleKeyNumbers}
            />
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Unit Code</label>
            <InputForm
              placeholder={""}
              value={data.unitcode}
              onChange={(val: any) => {
                let value = val.target.value;
                onChange("unitcode", value);
              }}
              isDisabled={disabled}
              onKeyPress={handleKeyNumbers}
            />
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Company</label>
            <InputForm
              placeholder={""}
              value={data.company}
              onChange={(val: any) => {
                let value = val.target.value;
                onChange("company", value);
              }}
              isDisabled={disabled}
              onKeyPress={handleKeyNumbers}
            />
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Sector</label>
            <InputForm
              placeholder={""}
              value={data.sector}
              onChange={(val: any) => {
                let value = val.target.value;
                onChange("sector", value);
              }}
              isDisabled={disabled}
              onKeyPress={handleKeyNumbers}
            />
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Email ID</label>
            <InputForm
              placeholder={""}
              value={data.emailId}
              onChange={(val: any) => {
                let value = val.target.value;
                onChange("emailId", value);
              }}
              isDisabled={disabled}
              onKeyPress={handleKeyNumbers}
            />
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Mobile No</label>
            <InputForm
              placeholder={""}
              value={data.mobileNo}
              onChange={(val: any) => {
                let value = val.target.value;
                onChange("mobileNo", value);
              }}
              isDisabled={disabled}
              onKeyPress={handleKeyNumbers}
            />
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Location</label>
            <InputForm
              placeholder={""}
              value={data.location}
              onChange={(val: any) => {
                let value = val.target.value;
                onChange("location", value);
              }}
              isDisabled={disabled}
              onKeyPress={handleKeyNumbers}
            />
          </div>
          <div
            className={
              imageEyeIconVisibleNextTab ? "col-lg-3 col-sm-3 col-xs-3 " + imageEyeIconVisibleNextTab : "col-lg-4 col-sm-4 col-xs-4 " + imageEyeIconVisibleNextTab
            }
          >
            <div className="form-group"></div>
            <label>Upload Current Month Salary Slip</label>
            <sup>*</sup>

            <input
              autoComplete={AutoCompleteValue}
              name="file-8[]"
              id="file-8-uploadSalarySlip"
              className="form-control inputfile inputfile-6"
              onChange={(e) => onChangeUploadSalarySlip("uploadSalarySlip", e)}
              type="file"
              disabled={salarySlipUploadDisabled}
            />
            <label htmlFor="file-8-uploadSalarySlip" className="form-control" style={{ border: "1px" }}>
              <span style={{ float: "right" }}>{salarySlipName}</span>
              <strong
                style={{
                  width: "30%",
                  left: "0",
                  borderTopRightRadius: "0",
                  borderBottomRightRadius: "0",
                }}
              >
                <i className="far fa-file"></i> Browse
              </strong>{" "}
            </label>
            <div>
              <p style={{ fontSize: "11px" }}> File extension should be jpg, png and pdf</p>
            </div>

            {error[salarySlipName] || error["salarySlipError"] ? <p style={{ color: "red" }}>{error[salarySlipName] || error["salarySlipError"]}</p> : ""}
          </div>
          {imageEyeIconVisibleNextTab && (
            <div className="col-lg-1 col-sm-1 col-xs-1 ">
              <div className="form-group"></div>
              <div
                className="form-control view_eye pe-pointer"
                style={{
                  border: "none",
                  order: "none",
                  position: "absolute",
                  right: "32px",
                  top: "47px",
                }}
                onClick={() => {
                  if (images?.[0]?.fileType === "pdf") {
                    window.open(images?.[0]?.src, "_blank");
                  } else {
                    setImageIndex(0);
                  }
                }}
              >
                <i className="fa fa-eye" aria-hidden="true"></i>
                {/* <Tooltip title="Click to view image">
                <div className="d-inline-block">
                  <BsImage color="#DB233A" className="mr-2" />
                  <span>{salarySlipName}</span>
                </div>
              </Tooltip> */}
              </div>
            </div>
          )}
        </div>
      </div>
      {[LoanStatus.LoanModule_Draft, LoanStatus.LoanModule_RejectedByInternalTeam].includes(approvalStatus) && context?.CurrentRoleId === RoleEnum.Member && (
        <div>
          <div className="p-2 d-flex justify-content-end" style={{ marginTop: 50 }}>
            <ButtonComponent
              icon={""}
              value={
                <p>
                  <i className="far fa-times-circle"></i> Cancel
                </p>
              }
              style={{ marginLeft: "10px" }}
              className="btn btn-primary"
              onClick={() => navigate("/LoanApprovalDashboard")}
            />
            <ButtonComponent
              icon={"fas fa-arrow-right"}
              value={buttonDisabled ? "Save & Next" : "Next"}
              style={{ marginLeft: "10px" }}
              id={"saveBtn"}
              onClick={goNext ? onSubmit : GoToNextTab}
            />
          </div>
        </div>
      )}

      <ImageViewer open={showImageViewer} images={images} imageIndex={imageIndex} onClose={() => setShowImageViewer(false)} />
    </div>
  );
};

export default LAPersonalDetails;
